import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';

import { NotificationService } from '../services/notification.service';
import { readHttpErrorNotice } from '../utils/http-error.util';

/** Set on requests whose caller shows its own toast, so this interceptor does not add a second one. */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notifications = inject(NotificationService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && !req.context.get(SKIP_ERROR_TOAST)) {
        const notice = readHttpErrorNotice(err, 'Please try again.');
        notifications.push({
          type: 'error',
          title: notice.title,
          message: notice.message
        });
      }
      return throwError(() => err);
    })
  );
};

